module.exports = __webpack_public_path__ + "media/images/front/bg_columns_header-cf242301119c730f958174d6150cd0ca.jpg";